module.exports = __webpack_public_path__ + "media/images/expert-slide3-8d535394a9625d11dc40d1183d65ee9a9ba096d1c21fdb6c5b4ed5b83c7ea566.jpg";